enum MODULE {
  NONE,
  DATA_SOURCE,
  RENDERER,
  ACTION,
}

export default MODULE;
